import * as Sentry from '@sentry/react';

// Sentry 초기화
export const initSentry = () => {
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
  const environment = process.env.NODE_ENV;

  if (SENTRY_DSN && environment === 'production') {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 0.1, // 10% 트랜잭션 추적 (비용 절감)
      // Session Replay
      replaysSessionSampleRate: 0.1, // 10% 세션 녹화
      replaysOnErrorSampleRate: 1.0, // 에러 발생 시 100% 녹화
    });

    console.log('[SENTRY] Initialized in production mode');
  } else {
    console.log('[SENTRY] Disabled (dev mode or no DSN)');
  }
};

export default Sentry;

